import {Component, OnInit, Input, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.html',
    encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnInit {

    @Input() message: any;

    constructor() {

    }

    ngOnInit() {
    }

}
